/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ColumnOut } from './columnOut';

export interface ColumnsOut {
  builtins: ColumnOut[];
  custom: ColumnOut[];
  version: string;
}
